require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./quarterly-newsletter.json") })
        }
      }, "path---quarterly-newsletter");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---quarterly-newsletter!./.cache/json/quarterly-newsletter.json
// module id = 1197
// module chunks = 231608221292675